/**
* DevExpress Dashboard (chart-pane.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { ModelSerializer, deserializeArray } from '@devexpress/analytics-core/analytics-utils';
import { SerializableModel } from '../../serializable-model';
import { ChartSeriesCreator } from './chart-series-creator';
import { chartPaneSerializationsInfo } from './metadata/_chart-pane';
export class ChartPane extends SerializableModel {
    constructor(dataItemProvider, dashboardItemJSON = {}, serializer = new ModelSerializer()) {
        super(dashboardItemJSON, serializer);
        this.createSeriesByViewType = ChartSeriesCreator.getSeriesCreator(dataItemProvider);
        this.series = deserializeArray(dashboardItemJSON.Series, (item) => ChartSeriesCreator.createSeries(dataItemProvider, item, serializer));
    }
    dispose() {
        super.dispose();
        this.disposeObservableArray(this.series);
    }
    getInfo() {
        return chartPaneSerializationsInfo;
    }
}
